<template xmlns:v-for="http://www.w3.org/1999/xhtml">
    <div class="d-flex flex-column">
        <b-container fluid class="flex-grow-1 d-flex flex-column h-100">
            <!-- User Interface controls -->
            <b-row class="flex-shrink-0">
                <b-col >
                    <b-card-group class="couriers">
                        <b-card no-body class="controlCouriers">
                            <b-button @click="openShiftModal()" class="h-100" variant="danger"><icon name="flag-checkered"></icon></b-button>
                        </b-card>
                        <perfect-scrollbar class="d-flex couriers-ps">
                          <b-card no-body class="" v-for="cour in couriersOnWork" :key="cour.id" @click="selectCourier(cour)" :class="{activeIt: selectedCourier === cour.id}" >
                            <h6 slot="header" class="mb-0 d-flex flex-row justify-content-between">
                                <div class="courier-info">
                                  <div>
                                    <b>{{cour.id}} - {{shortNameWorker(cour)}}</b>
                                  </div>
                                  <div>
                                    <b>{{cour.phoneNumber}}</b>
                                  </div>
                                </div>
                                <b-button @click.stop="openModalCloseShift(cour)" class="px-2 py-0 pb-1" variant="danger">
                                    <icon name="times"></icon>
                                </b-button>
                            </h6>
                            <b-list-group flush class="courier-statuses">
                                <b-list-group-item class="d-flex justify-content-between align-items-center">
                                    <span>
                                      {{cour.status && courierStages.length !== 0
                                        ? cour.status.name
                                        : courierStageWaiting
                                          ? courierStageWaiting.name
                                          : ''}}
                                    </span>
                                    <span v-if="cour.status && cour.status.keyword === STATUS_WORKER.DELIVERED">
                                      <b-button
                                        @click.stop="courierArrived(cour)"
                                        class="px-2 py-0 pb-1"
                                        variant="success">
                                        <icon name="check"></icon>
                                      </b-button>
                                    </span>
                                </b-list-group-item>
                            </b-list-group>
                        </b-card>
                        </perfect-scrollbar>
                        <b-card no-body class="controlCouriers">
                            <b-button v-b-modal.addCourier class="h-100" variant="success" @click="getCouriersFree">
                              <icon name="plus"></icon>
                            </b-button>
                        </b-card>
                    </b-card-group>
                    <b-modal id="addCourier" ok-only>
                        <span v-if="couriersFree.length === 0">Свободных курьеров не найдено</span>
                        <b-card no-body class="mb-2" v-for="cour in couriersFree" :key="cour.id" >
                            <b-list-group flush >
                                <b-list-group-item>
                                    <div class="mb-0 d-flex justify-content-between align-items-center"><b>{{cour.id}} - {{fullNameWorker(cour)}} - {{cour.phoneNumber}}</b> <b-button @click="changeCourierStatus(cour, true)"  class="h-100" variant="success"><icon name="plus"></icon></b-button></div>
                                </b-list-group-item>
                            </b-list-group>
                        </b-card>
                    </b-modal>
                </b-col>
            </b-row>
            <b-row class="flex-grow-1">
                <b-col  md="3" class=" d-flex flex-column h-100">
                    <b-card no-body class="my-3 flex-grow-1 h-100">
                        <b-tabs card  class="flex-grow-1 tabs-delivery d-flex flex-column"
                                content-class="d-flex flex-column flex-grow-1 flex-tab">
                            <b-tab title="На доставку" class="px-0 py-0 flex-grow-1 h-100">
                                <perfect-scrollbar class="flex-basis-0 flex-grow-1 deliveries-orders" :options="opsScroll">
                                  <b-list-group flush class="orders">
                                    <b-card-body class="text-center" v-if="deliveryOrders.length === 0">Нет заказов в работе</b-card-body>
                                    <b-list-group-item
                                      v-for="ord in deliveryOrders"
                                      :key="ord.id"
                                      :class="{ activeIt: selectedOrders.includes(ord.id) }"
                                      @click="switchItems(selectedOrders, ord.id, 'orderCollecting')"
                                    >
                                      <order-block type="delivery" :order="ord" :order-stages="orderStagesObj" />
                                      <b-button class="mt-1" v-b-toggle="'deliv-' + ord.id" @click.stop="" variant="primary">
                                        Продукты
                                        <icon title="Продукты" name="shopping-cart"></icon>
                                      </b-button>
                                      <b-collapse class="mt-1" :id="'deliv-' + ord.id">
                                        <b-card v-for="product in ord.prods.nodes"
                                                :key="product.id">
                                          {{ product.name}}
                                        </b-card>
                                      </b-collapse>
                                    </b-list-group-item>
                                  </b-list-group>
                                </perfect-scrollbar>
                                <b-button
                                  v-if="deliveryOrders.length !== 0 && CAA_IS_ON === false && IS_SUPER_LOGISTICIAN"
                                  :disabled="selectedOrders.length === 0" variant="success"
                                  size="sm w-100 mb-1 mt-1"
                                  @click="unionOrders"
                                >
                                  Объединить
                                </b-button>
                            </b-tab>
                            <b-tab title="Самовывоз" class="px-0 py-0 flex-grow-1 h-100">
                                <perfect-scrollbar class="flex-grow-1 flex-basis-0 pickup-orders" :options="opsScroll">
                                    <b-card-body class="text-center" v-if="pickupOrders.length === 0">Нет заказов в работе</b-card-body>
                                    <b-card v-for="order in pickupOrders"
                                            :key="order.id" >
                                        <order-block
                                          class="pointer"
                                          type="delivery"
                                          v-b-toggle="'delivery-' + order.id"
                                          :order="order"
                                          :order-stages="orderStagesObj"
                                        />
                                        <b-collapse  :id="'delivery-' + order.id">
                                            <b-card v-for="product in order.prods.nodes"
                                                    :key="product.id">
                                                {{ product.name}}
                                            </b-card>
                                        </b-collapse>
                                        <b-row class="mt-1">
                                            <b-col md="6">
                                                <b-btn class="w-100" variant="danger"
                                                       @click="cancelOrder(order)">Отмена заказа
                                                </b-btn>
                                            </b-col>
                                            <b-col md="6">
                                                <b-btn class="w-100" variant="success"
                                                       @click="confirmOrder(order)">Оплата
                                                </b-btn>
                                            </b-col>
                                        </b-row>
                                    </b-card>
                                </perfect-scrollbar>
                            </b-tab>
                        </b-tabs>
                        <div slot="footer" class="d-flex justify-content-between align-items-center">
                            <b-form-checkbox id="mapShowOrders" class="checkbox-header mr-0"
                                 v-model.number="mapShowOrders"
                                 value="1"
                                 unchecked-value="0">
                                На карте
                            </b-form-checkbox>
                        </div>
                    </b-card>
                </b-col>
                <b-modal id="ordersList" body-class="px-0 py-0">
                    <b-list-group-item v-for="ord in deliveryOrders" ok-only="true" :key="ord.id" >
                      <order-block type="delivery" :order="ord" :order-stages="orderStagesObj" />
                    </b-list-group-item>
                </b-modal>
                <b-col md="3" class="d-flex flex-column h-100">
                    <b-card no-body class="my-3 flex-grow-1">
                        <h6 slot="header"
                            class="mb-0 d-flex justify-content-between align-items-center"
                        >
                          <span><b>Доставки:</b>
                            <b-badge class="ml-1" variant="success">{{selectedDeliveries.length}}</b-badge>
                          </span>
                          <span>
                            <b-spinner type="border" v-if="isGivingToCourier" variant="dark" small></b-spinner>
                            <b-button @click="giveToCourier()" :disabled="!permitGiveCourier" size="sm" variant="success">Отдано</b-button>
                          </span>
                          <b-button v-if="IS_SUPER_LOGISTICIAN" @click="appointCourier" :disabled="selectedDeliveries.length === 0 || selectedCourier === null" size="sm" variant="success">Назначить</b-button>
                        </h6>
                        <perfect-scrollbar class="flex-grow-1 flex-basis-0" :options="opsScroll">
                            <b-list-group flush class="deliveries">
                                <b-card-body class="text-center" v-if="deliveriesWork.length === 0">Нет доставок в работе</b-card-body>
                                <delivery-item
                                  v-for="del in deliveriesWork"
                                  :key="del.id"
                                  :delivery="del"
                                  :numberSelectedOrders="numberSelectedOrders"
                                  :couriers="couriersOnWork"
                                  :class="{activeIt: selectedDeliveries.includes(del.id)}"
                                  :order-stages="orderStagesObj"
                                  @click.native="switchItems(selectedDeliveries, del.id, 'delivery')"
                                  @change-courier="giveToCourier($event.delivery, $event.courier)"
                                  @disband-delivery="disbandDelivery($event)"
                                  @add-order-to-delivery="addOrderToDelivery($event)"
                                  type="delivery-list-in-work"
                                  :CAA="CAA_IS_ON"
                                />
                            </b-list-group>
                        </perfect-scrollbar>
                        <div slot="footer" class="d-flex justify-content-between align-items-center">
                            <b-button v-b-modal.deliveriesList  size="sm" variant="primary">
                              Все доставки <b-badge class="ml-1" variant="light">{{deliveries.length}}</b-badge>
                            </b-button>
                            <b-button @click="setImportanceDelivery()"  size="sm" variant="danger" :disabled="selectedDeliveries.length === 0">Срочно</b-button>
                            <b-form-checkbox id="mapShowDeliveries" class="checkbox-header mr-0"
                             v-model.number="mapShowDeliveries"
                             value="1"
                             unchecked-value="0">
                                На карте
                            </b-form-checkbox>
                        </div>
                    </b-card>
                </b-col>
                <b-modal id="deliveriesList" ok-only body-class="px-0 py-0" @hide="deliveryListHide">
                    <b-list-group flush class="deliveries">
                        <b-card-body class="text-center" v-if="deliveries.length === 0">Нет доставок в работе</b-card-body>
                        <delivery-item v-for="del in deliveries" :key="del.id"
                          type="delivery-list-all"
                          :delivery="del"
                          :numberSelectedOrders="numberSelectedOrders"
                          :couriers="couriersOnWork"
                          :selectedOrders="selectedOrdersModal"
                          :selectedDelivery.sync="selectedDeliveryModal"
                          :isInModal="true"
                          :role="$user.get().role"
                          :order-stages="orderStagesObj"

                          @select-order="selectOrder($event.order)"
                          @change-courier="giveToCourier($event.delivery, $event.courier)"
                          @assign-courier="assignToCourier($event.delivery, $event.courier)"
                          @disband-delivery="disbandDelivery($event)"
                          @add-order-to-delivery="addOrderToDelivery($event)"
                        ></delivery-item>
                    </b-list-group>
                </b-modal>
                <b-col md="6">
                    <yandex-map class="my-3"
                            :coords="mapCenter"
                            zoom="12"
                            style="width: 100%; height: 650px;"
                            :cluster-options="{
                                1: {clusterDisableClickZoom: true}
                              }"
                            :controls="['trafficControl', 'zoomControl', 'searchControl']"
                            :detailed-controls="{ searchControl: { provider: yandexSearchProvider } }"
                            @map-was-initialized="initHandler"
                    >
                        <ymap-marker v-for="placemark in placemarks" :key="placemark.markerId"
                                     :marker-id="placemark.markerId"
                                     :marker-type="placemark.markerType"
                                     :coords="placemark.coords"
                                     :icon="placemark.icon"
                                     :callbacks="{
                                      click: markerClicked
                                     }"
                                     :properties="{ iconCaption: placemark.iconCaption }"
                        ></ymap-marker>
                    </yandex-map>
                </b-col>
            </b-row>
        </b-container>
        <modal-payment-info ref="modalPayment" @updated-payment="updatedPayment" :order="currentOrder" :pickup="true"/>
        <b-modal
          id="closeShift"
          modal-class="fullSizeModal"
          size="lg"
          title="Закрытие смены"
          ref="closeShift"
          @ok="closeShift"
          @hide="onHideCloseShiftModal"
          :ok-disabled="this.$moment(this.shiftDay).format('YYYY-MM-DD') !== this.$moment().format('YYYY-MM-DD') || (currentShift && currentShift.dateClosed !== null)"
          @cancel="printCouriersReportOrders"
          ok-title="Закрыть смену"
          cancel-title="Напечатать"
          cancel-variant="info"
          :cancel-disabled="couriersStats.length === 0"
        >
          <template slot="modal-header">
            <div>
              <b class="mr-2">Смена:</b>
              <el-date-picker
                :picker-options="datePickerOptions"
                value-format="yyyy-MM-dd"
                format="dd.MM.yyyy"
                v-model="shiftDay"
                type="date"
                class="mr-2"
                placeholder="Выбрать день"
                disabledDate="disabledDate"
              >
              </el-date-picker>
              <div class="d-inline" v-if="shiftOpened">
                <span class="mr-1">Смена открыта: {{shiftOpened}}</span>
                <span class="mr-1" v-if="isShiftClosed === true">|</span>
                <span class="mr-1" v-if="isShiftClosed === true">Смена закрыта: {{shiftClosed}}</span>
              </div>
            </div>

          </template>
              <div class="d-flex mb-2">
                <span>Наведи, чтобы узнать что значит каждый цвет заказа</span>
                <div class="ml-2">
                  <div class="rectangle" style="background-color: rgb(226, 255, 230);" v-b-tooltip.hover title="Заказ доставлен вовремя (приготовление - доставлен)"></div>
                  <div class="rectangle" style="background-color: rgb(118, 234, 134);" v-b-tooltip.hover title="Курьер доставил заказ за соответствующее время, за что получит вознаграждение (отправлен - доставлен)"></div>
                  <div class="rectangle" style="background-color: rgb(255, 204, 204);" v-b-tooltip.hover title="Заказ доставлен с опозданием (приготовление - доставлен)"></div>
                </div>
              </div>
              <b-spinner type="border" v-if="loadingCouriersOrders" variant="dark" small></b-spinner>
              <b-table hover
                     @row-clicked="toggleCourierOrders"
                     :busy="loadingCouriersOrders"
                     striped
                     show-empty
                     foot-clone
                     empty-text="Нет данных за текущую смену"
                     :fields="fieldsStat"
                     :items="couriersStats"
                     tbody-class="scroll-y"
                     class="mb-0 table-orders"
                     :tbody-tr-class="rowClasses"
            >
                <template slot="courier" slot-scope="data">
                    <div>
                      <order-row :item="data" />
                    </div>
                    <b-button v-if="data.item.order && data.item.order.paymentChanged && !data.item.order.paymentChangingMarked" size="sm" @click="confirmPaymentChanged(data.item.order)" variant="danger">Забили в айку</b-button>
                </template>
                <template slot="FOOT_courier" slot-scope="data">
                    <b>Общая сумма:</b>
                </template>
                <template slot="orderTotalTime" slot-scope="data">
                    <div v-b-tooltip.hover title="Время приготовления + сборка + доставка">
                      {{ getTimeTitle(data.item) }}
                    </div>
                </template>
                <template slot="notEndedOrdersCount" slot-scope="notEndedOrdersCount">
                  <span>{{notEndedOrdersCount.value}}</span>
                </template>
                <template slot="cash" slot-scope="cash">
                    {{cash.value}} руб.
                </template>
                <template slot="cardInPlace" slot-scope="cardInPlace">
                    {{cardInPlace.value}} руб.
                </template>
                <template slot="cardOnline" slot-scope="cardOnline">
                    {{cardOnline.value}} руб.
                </template>
                <template slot="sberbank" slot-scope="sberbank">
                    {{sberbank.value}} руб.
                </template>
                <template slot="paymentLink" slot-scope="paymentLink">
                    {{paymentLink.value}} руб.
                </template>
                <template slot="ordersCount" slot-scope="ordersCount">
                    {{ordersCount.value}}
                </template>
                <template slot="total" slot-scope="total">
                    {{total.value}} руб.
                </template>
                <template slot="salary" slot-scope="data">
                    {{data.item.salary + (data.item.inTime && data.item.inTime.sum ? data.item.inTime.sum : 0) }} руб.
                </template>
                <template slot="motivation" slot-scope="data">
                  {{data.item.motivation }} руб.
                </template>
                <template slot="gived" slot-scope="data">
                  {{data.item.gived }} руб.
                </template>
                <template slot="FOOT_salary" slot-scope="data">
                    {{sumSalary}} руб.
                </template>
                <template slot="FOOT_motivation" slot-scope="data">
                  {{sumMotivation}} руб.
                </template>
                <template slot="FOOT_cash" slot-scope="data">
                    <b>{{sumCash}} руб.</b>
                </template>
                <template slot="FOOT_cardInPlace" slot-scope="data">
                    <b>{{sumCardInPlace}} руб.</b>
                </template>
                <template slot="FOOT_cardOnline" slot-scope="data">
                    <b>{{sumCardOnline}} руб.</b>
                </template>
                <template slot="FOOT_sberbank" slot-scope="data">
                    <b>{{sumSberbank}} руб.</b>
                </template>
                <template slot="FOOT_paymentLink" slot-scope="data">
                    <b>{{sumPaymentLink}} руб.</b>
                </template>
                <template slot="FOOT_total" slot-scope="data">
                    <b>{{couriersStats.reduce((val, el) => { return val + (el.courier || el.pickup ? parseInt(el.total) : 0) }, 0)}} руб.</b>
                </template>
              </b-table>
            <div class="mt-5" v-if="currentShift">
                <b-spinner v-if="loadingSpending" class="mb-1" small></b-spinner>
                <b-table hover
                         striped
                         fixed
                         :busy="loadingSpending"
                         foot-clone
                         show-empty
                         empty-text="Дополнительных расходов внесено не было"
                         :fields="[
                           {
                             key: 'title',
                             label: 'Трата'
                           },
                           {
                             key: 'sum',
                             label: 'Сумма'
                           },
                            {
                             key: 'del',
                             label: '',
                             class: 'icon-col'
                           },
                         ]"
                         :items="additionalSpending"
                         tbody-class="scroll-y"
                         class="mb-0 table-orders"
                         tbody-tr-class="order-prods"
                >
                    <template slot="del" slot-scope="data">
                        <b-button v-if="!data.item.hideDelete" size="md" @click="deleteSpending(data.item)" variant="danger"><icon name="trash-alt"></icon></b-button>
                    </template>
                    <template slot="FOOT_title" slot-scope="data">
                        <b>Итого расходов:</b>
                    </template>
                    <template slot="FOOT_sum" slot-scope="data">
                        <b>{{additionalSpending.reduce((val, el) => {return val + parseFloat(el.sum)}, 0)}} руб.</b>
                    </template>
                </b-table>
                <b-row class="d-flex mt-3 justify-content-between align-items-end">
                    <b-col md="6">
                        <b-form-group
                          class="mb-0 mr-2 flex-grow-2"
                          label="Статья расходов:"
                          label-for="Input1">
                          <b-form-input id="Input1"
                            v-model="spend.title"
                            required
                            placeholder="Введите статью расходов">
                          </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" class="w-100 d-flex align-items-end">
                        <b-form-group
                                class="mb-0 mr-3 flex-grow-1"
                                label="Сумма:"
                                label-for="Input1">
                            <b-form-input id="Input1"
                                          v-model.number="spend.sum"
                                          type="number"
                                          required
                                          placeholder="Введите сумму">
                            </b-form-input>
                        </b-form-group>
                        <b-button size="md" @click="addSpend()" variant="success">Добавить</b-button>
                    </b-col>
                </b-row>
            </div>
            <b-list-group-item class="mt-5" v-if="sumCash !== 0 || sumSalary !== 0 || sumCosts !== 0 || sumInTime !== 0">
                <div class="d-flex justify-content-between align-items-center">
                    <b>Итого:</b>
                    <b>
                      <b-button v-b-popover.hover.top="'Сумма заказов'" variant="outline-info">{{sumCash}}</b-button> -
                      <b-button v-b-popover.hover.top="'Сумма заработанная курьерами'" variant="outline-info">{{sumSalary}}</b-button> -
                      <b-button v-b-popover.hover.top="'Сумма расходов'" variant="outline-info">{{sumCosts}}</b-button> -
                      <b-button v-b-popover.hover.top="'Сумма мотивации курьеров'" variant="outline-info">{{sumMotivation}}</b-button> =
                      <b-button v-b-popover.hover.top="'Общая сумма'" variant="outline-info">{{sumCash - sumSalary - sumMotivation - sumCosts}}</b-button> руб.
                    </b>
                </div>
            </b-list-group-item>
        </b-modal>
        <b-modal
          ref="courStat"
          :title="courierModal ? 'Закрытие смены: ' + fullNameWorker(courierModal) : ''"
          ok-title="Закрыть смену курьера"
          :ok-disabled="courierModal && (!courierModal.status || courierModal.status.keyword !== STATUS_WORKER.WAITING)"
          :ok-only="true"
          @ok="changeCourierStatus(courierModal, false)"
          @hide="courierModal = null"
        >
            <courier-stat-display ref="courStats" :orders="courierStat"/>
            <template v-if="courierModal">
                <div class="mt-2" v-if="!courierModal.status || courierModal.status.keyword !== STATUS_WORKER.WAITING"><b>Перед закрытием смены, подтвердите возвращение курьера</b></div>
            </template>
        </b-modal>
        <cancel-order-modal ref="causeCancelOrder" :orderId="orderIdForCancel" :statusOptions="orderStages" @order-canceled="orderCanceled"></cancel-order-modal>
    </div>
</template>
<script>
import commonVar from '@/tempVariables/commonVars'
import ModalPaymentInfo from '@/components/ModalPaymentInfo'
import CourierStatDisplay from '@/components/CourierStatDisplay'
import graphqlLogistian from '../graphql/logistian'
import CancelOrderModal from './modals/CancelOrder'
import DeliveryItem from './DeliveryItem'
import modalMixin from '../mixins/modalMixin'
import TimeCounter from './common/TimeCounter'
import Vue from 'vue'
import {
  USER_ROLE_SUPER_LOGISTICIAN
} from '@/constants/roles'

import {
  DELIVERY_ORDERS_QUERY,
  PICKUP_ORDERS_QUERY,
  UPDATE_WORKER_STATUS_MUTATE,
  STAGES_WORKERS_QUERY,
  STATUS_QUERY,
  STAGES_DELIVERY_QUERY,
  DELIVERIES_QUERY,
  UPDATE_ORDER_PRIORITY,
  DELETE_DELIVERY,
  CREATE_SPENDING,
  DELETE_SPENDING,
  SPENDINGS_BY_DATE,
  SHIFT_CLOSE,
  PRINT_REPORT_COURIERS_ORDERS,
  SHIFT_COURIERS_CHECK,
  GET_SHIFT_LOGISTIAN_BY_DAY,
  UPDATE_ORDER_DELIVERY,
  SH_GEOCODE_CRM,
  COURIER_STATS,
  COURIER_DELIVERIED_ORDERS,
  FREE_COURIERS_QUERY,
  REST_POINT_COURIERS_QUERY,
  UPDATE_ORDER_MUTATE,
  ORDER_PAYMENT_BY_ID_ORDER_QUERY
} from '@/constants/graphql'
import {
  STATUS_WORKER,
  STATUS_DELIVERY,
  STATUS_ORDER,
  TYPE_DELIVERY
} from '@/constants/keywords'
import orderFunc from '@/functionsLib/orderFunc'
import brandQueries from '../graphql/brand'
import configQueries from '../graphql/config'
import OrderRow from './ordersDelivery/OrderRow.vue'
import queries from '../constants/graphqlOrderManagment'
import { yandexSearchProvider as yandexSearchProviderModule } from '@/helpers/yandexSearchControlProvider'

export default {
  name: 'OrdersDelivery',
  mixins: [modalMixin],
  apollo: {
    accountRestPoint: {
      query: brandQueries.CURRENT_REST_POINT,
      update (data) {
        const accountRestpoint = data.accountRestpoint || {}

        if (accountRestpoint.CAA) {
          this.$apollo.queries.accountRestPoint.setOptions({
            pollInterval: 10000
          })
        }

        return accountRestpoint
      }
    },
    fuelPrice: {
      query: configQueries.getConfigRecord,
      variables () {
        return {
          param: 'fuel_price_per_km'
        }
      },
      update (data) {
        return parseFloat(data.allConfigs.nodes[0].value)
      }
    },
    deliveries: {
      query: DELIVERIES_QUERY,
      pollInterval: 10000,
      update (data) {
        if (data.deliveriesLogistic) {
          let deliveries = data.deliveriesLogistic.nodes
          let deliveriesArray = []
          if (deliveries) {
            deliveries.forEach(del => {
              let orders = del.ordersRaw.nodes ? this.copyObj(del.ordersRaw.nodes) : []
              del = Object.assign({}, {orders: orders}, del)
              deliveriesArray.push(del)
            })
          } else {
            deliveries = []
          }
          return deliveriesArray
        } else {
          return []
        }
      }
    },
    orders: {
      query: DELIVERY_ORDERS_QUERY,
      pollInterval: 10000,
      update (data) {
        this.setCurrentMapPosition()
        if (data.deliveryOrders) {
          return data.deliveryOrders.nodes
        } else {
          return []
        }
      }
    },
    courierStages: {
      query: STAGES_WORKERS_QUERY,
      update (data) {
        return data.allStageWorkers.nodes
      }
    },
    deliveryStages: {
      query: STAGES_DELIVERY_QUERY,
      update (data) {
        return data.allStageDeliveries.nodes
      }
    },
    orderStages: {
      query: STATUS_QUERY,
      update (data) {
        return data.allStageOrders.nodes
      }
    },
    courierStat: {
      query: COURIER_DELIVERIED_ORDERS,
      skip () {
        return !this.courierModal
      },
      variables () {
        const day = this.shiftDay ? this.shiftDay : new Date()
        const params = {
          day: this.$moment(day).format('YYYY-MM-DD'),
          workerID: this.courierModal.id || 0
        }

        return params
      },
      fetchPolicy: 'network-only',
      update (data) {
        return data.courierDeliveriedOrders.nodes
      }
    },
    couriersOnWork: {
      query: REST_POINT_COURIERS_QUERY,
      variables () {
        return {
          idRestPoint: this.$userControl.jwtParsed.rest_point_id
        }
      },
      pollInterval: 10000,
      update (data) {
        const couriers = data.allWorkers.nodes || []
        couriers.map(cour => {
          cour.status = this.courierStages.find(stage => stage.id === cour.idStageWorker)
        })

        return couriers
      }
    },
  },
  data: function () {
    return {
      couriersFree: [],
      fuelPrice: 0,
      productsButtonToggle: false,
      datePickerOptions: {
        disabledDate (date) {
          return date > new Date()
        }
      },
      selectedDeliveryModal: null,
      selectedOrdersModal: [],
      currentShift: null,
      loadingShift: false,
      loadingCouriersOrders: false,
      loadingPickup: false,
      loadingSpending: false,
      shiftDay: new Date(),
      showAllShifts: false,
      showedOrders: [],
      accountRestPoint: null,
      prevMapPosition: {x: null, y: null},
      map: null,
      // Центр карты (Тюмень). Именно стабильная ссылка из data, а не литерал в шаблоне:
      // литерал создаёт новый массив при каждой перерисовке, и vue-yandex-maps делает
      // panTo на эти координаты - карта "сама" возвращается к Тюмени каждые ~10 сек
      // (поллинг заказов), сбрасывая позицию после поиска адреса.
      mapCenter: [57.137170, 65.546001],
      additionalSpending: [],
      filterCouriers: '',
      opsScroll: commonVar.opsPerfectScroll,
      icon: {color: 'green', glyph: 'cinema'},
      STATUS_WORKER,
      STATUS_DELIVERY,
      courierModal: null,
      orders: [],
      currentOrder: null,
      deliveryStages: [],
      courierStages: [],
      orderStages: [],
      deliveryForDelete: {id: null, orders: []},
      mapShowOrders: 1,
      orderIdForCancel: null,
      mapShowDeliveries: 0,
      courierStat: [],
      showedCourierOrders: new Map(),
      spend: {
        title: '',
        sum: null
      },
      placemarks: [],
      deliveries: [],
      selectedOrders: [],
      selectedDeliveries: [],
      isGivingToCourier: false,
      selectedCourier: null,
      ordersByCourier: new Map(),
      fieldsStat: [
        {
          key: 'paymentChanged',
          label: '',
          tdClass: (value, key, item) => {
            if (item.courier) {
              if (item.paymentChanged) { return 'courier-payment-changed' } else return null
            } else {
              return item.paymentChanged && !item.paymentChangingMarked ? 'payment-changed' : null
            }
          },
          formatter: () => {
            return ''
          }
        },
        {
          key: 'courier',
          label: 'Заказы'
        },
        {
          key: 'notEndedOrdersCount',
          label: 'Кол-во активных доставок'
        },
        {
          key: 'orderTotalTime',
          label: 'Общее время'
        },
        {
          key: 'cash',
          label: 'Наличные'
        },
        {
          key: 'cardInPlace',
          label: 'Безналичные'
        },
        {
          key: 'cardOnline',
          label: 'Оплата онлайн'
        },
        {
          key: 'sberbank',
          label: 'Аванс'
        },
        {
          key: 'paymentLink',
          label: 'Плат. ссылка'
        },
        {
          key: 'ordersCount',
          label: 'Кол-во заказов'
        },
        {
          key: 'total',
          label: 'Итого'
        },
        {
          key: 'salary',
          label: 'Заработано'
        },
        {
          key: 'motivation',
          label: 'Мотивация'
        },
        {
          key: 'gived',
          label: 'К сдаче'
        }
      ],
      pickupFields: [
        {
          key: 'orderNumber',
          label: 'Заказ №',
          sortable: true
        },
        {
          key: 'cash',
          label: 'Наличные',
          sortable: true
        },
        {
          key: 'cardInPlace',
          label: 'Безналичные',
          sortable: true
        },
        {
          key: 'cardOnline',
          label: 'Оплата онлайн',
          sortable: true
        },
        {
          key: 'sberbank',
          label: 'Аванс',
          sortable: true
        },
        {
          key: 'paymentLink',
          label: 'Плат. ссылка',
          sortable: true
        },
        {
          key: 'total',
          label: 'Итого',
          sortable: true
        }
      ],
      pickupItems: [],
      pickupOrdersByDay: [],
      pagePickupCurrent: 1,
      pickupPerPage: 5,
      couriersStats: [],
      money: {
        orders: [
          {
            id: 10,
            paymentInfo: {
              cash: 100,
              card_in_place: 0,
              card_online: 0
            },
            deliveryPrice: 100
          },
          {
            id: 11,
            paymentInfo: {
              cash: 100,
              card_in_place: 100,
              card_online: 50
            },
            deliveryPrice: 120
          }
        ]
      }
    }
  },
  methods: {
    async couriersRefetch () {
      await this.getCouriersFree()
      await this.$apollo.queries.couriersOnWork.refetch()
    },
    getCouriersFree () {
      return this.$apollo.query({
        query: FREE_COURIERS_QUERY,
        fetchPolicy: 'network-only'
      }).then((res) => {
        this.couriersFree = res.data.allWorkers.nodes || []
      })
    },
    calculatateGSM (order) {
      if (order.autoAssignCourier) {
        let fuelPricePerKm = this.fuelPrice ? this.fuelPrice : 50
        return order.ymapsDistance ? parseInt(parseFloat(order.ymapsDistance) / 1000 * fuelPricePerKm) : 0
      } else return 0
    },
    selectCourier (cour) {
      if (this.CAA_IS_ON === false) {
        this.selectedCourier = (this.selectedCourier === cour.id) ? null : cour.id
      } else {
        this.selectedCourier = null
      }
    },
    onHideCloseShiftModal () {
      if (!this.shiftDay) {
        this.shiftDay = new Date()
      }
    },
    confirmPaymentChanged (order) {
      this.$apollo.mutate({
        mutation: UPDATE_ORDER_MUTATE,
        variables: {
          id: order.id,
          orderPatch: {
            paymentChangingMarked: true
          }
        }
      }).then((res) => {
        this.getDataShift()
      }).catch((err) => {
        console.log(err)
      })
    },
    deliveryListHide () {
      this.selectedOrdersModal = []
      this.selectedDeliveryModal = null
    },
    handlePickupOrders (date) {
      this.loadingPickup = true
      let promisePickup = []
      promisePickup.push(this.$apollo.query({
        query: PICKUP_ORDERS_QUERY,
        variables: {
          day: date
        },
        fetchPolicy: 'network-only'
      }))
      Promise.all(promisePickup).then(res => {
        this.loadingPickup = false
        if (res[0].data.pickupOrdersByDay) {
          let pickupStat = res[0].data.pickupOrdersByDay.nodes.map((order) => {
            let cash = parseInt(order.paymentInfo.cash)
            let cardInPlace = parseInt(order.paymentInfo.cardInPlace)
            let cardOnline = parseInt(order.paymentInfo.cardOnline)
            let sberbank = parseInt(order.paymentInfo.sberbank)
            let paymentLink = parseInt(order.paymentInfo.paymentLink)
            let discountSum = parseInt(order.badDiscount)
            return {
              order: order,
              cash: cash,
              cardInPlace: cardInPlace,
              cardOnline: cardOnline,
              sberbank: sberbank,
              paymentLink: paymentLink,
              discountSum: discountSum,
              total: cash + cardInPlace + cardOnline + sberbank + paymentLink,
              courier: null,
              gived: cash,
              orderTotalTime: 0,
              salary: 0,
              motivation: 0,
              inTime: null,
              pickup: true
            }
          })
          this.pickupItems = pickupStat
        }
      })
    },
    handleSpendings (date, discountSum = 0) {
      this.additionalSpending = []
      this.$apollo.query({
        query: SPENDINGS_BY_DATE,
        variables: {
          day: date,
          showAll: this.showAllShifts
        },
        fetchPolicy: 'network-only'
      }).then(res => {
        this.loadingSpending = false
        this.additionalSpending = this.additionalSpending.concat(res.data.answer.nodes)
      }).catch(err => {
        alert(err)
      })
    },
    getShift (date) {
      if (this.$userControl && this.$userControl.jwtParsed) {
        this.$apollo.query({
          query: GET_SHIFT_LOGISTIAN_BY_DAY,
          variables: {
            day: date,
            idW: !this.showAllShifts ? this.$userControl.jwtParsed.user_id : null
          },
          fetchPolicy: 'network-only'
        }).then(res => {
          this.currentShift = res.data.getShiftLogistianByDay
        })
      }
    },
    async closeAvailabilityCheck () {
      if (!this.$userControl || !this.$userControl.jwtParsed) {
        return false
      }

      const res = await this.$apollo.query({
        query: SHIFT_COURIERS_CHECK,
        fetchPolicy: 'network-only'
      })
        .then(res => res.data.shiftCouriersCheck)
        .catch(err => {
          console.log(err)
          return false
        })

      return res
    },
    printCouriersReportOrders (bvModalEvt) {
      bvModalEvt.preventDefault()
      let currentDate = this.shiftDay ? this.$moment(this.shiftDay).format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD')
      this.$apollo.mutate({
        mutation: PRINT_REPORT_COURIERS_ORDERS,
        variables: {
          date: currentDate
        }
      }).then(res => {
        console.log(res)
      })
    },
    rowClasses (item, type) {
      let classes = 'order-prods'
      // inTimeClear
      if (item && type === 'row') {
        if (item.inTime) classes += ' in-time'
        else classes += ' not-in-time'
        if (item.inTimeClear) classes += ' in-clear-time'
      }
      return classes
    },
    markerClicked (event) {
      let orderId = event.originalEvent.target.properties._data['markerId']
      this.switchItems(this.selectedOrders, orderId, 'orderCollecting')
    },
    cancelOrder (order) {
      this.orderIdForCancel = order.id
      this.$refs.causeCancelOrder.showModalCancel()
    },
    setCurrentMapPosition () {
      if (this.map) {
        let position = this.map.getGlobalPixelCenter()
        this.map.setGlobalPixelCenter([position[0], position[1]])
      }
    },
    setImportanceDelivery () {
      let updDeliveries = this.deliveries.filter((del) => {
        return this.selectedDeliveries.includes(del.id)
      })
      let promiseImportant = []
      updDeliveries.forEach(del => {
        del.orders.forEach(ord => {
          if (ord.stageKeyword !== STATUS_ORDER.COOKED || ord.stageKeyword !== STATUS_ORDER.COLLECTED) {
            promiseImportant.push(this.$apollo.mutate({
              mutation: UPDATE_ORDER_PRIORITY,
              variables: {
                idOrder: ord.id,
                priority: 1
              }
            }))
          }
        })
      })
      Promise.all(promiseImportant).then(values => {
        updDeliveries.forEach(del => {
          values.forEach(res => {
            let id = res.data.updateOrderPriority.integer
            let ord = del.orders.find(el => el.id === id)
            if (ord) {
              ord.priority = 1
            }
          })
        })
      })
    },
    addSpend () {
      if (this.spend.title !== '') {
        if (this.currentShift) {
          let currentDate = this.$moment().format('l')
          let selectedShiftDate = this.$moment(this.currentShift.dateOpened).format('l')
          let mergingSpendingOptions = {}
          if (selectedShiftDate !== currentDate) {
            mergingSpendingOptions = {
              creationTime: this.$moment(this.currentShift.dateOpened).add(10, 'minutes').format(),
              idRestPoint: this.$userControl.jwtParsed.rest_point_id
            }
          } else {
            mergingSpendingOptions = {
              idRestPoint: this.$userControl.jwtParsed.rest_point_id
            }
          }
          this.$apollo.mutate({
            mutation: CREATE_SPENDING,
            variables: {
              spending: Object.assign(mergingSpendingOptions, this.spend)
            }
          }).then(res => {
            this.handleSpendings(this.currentShift.dateOpened, 0)
            this.spend.title = ''
            this.spend.sum = null
          })
        } else {
          Vue.notify({
            group: 'callCenterInfo',
            type: 'error',
            title: 'Ошибка',
            text: 'Нет открытой смены на выбранную дату, вам не удастся добавить затраты',
            duration: 2000
          })
        }
      } else {
        Vue.notify({
          group: 'callCenterInfo',
          type: 'error',
          title: 'Ошибка',
          text: 'Заполните обязательные поля',
          duration: 2000
        })
      }
    },
    orderCanceled (orderId) {
      let canceledStage = this.orderStages.find(el => el.keyword === STATUS_ORDER.CANCELED)
      let order = this.orders.find(el => el.id === orderId)
      Object.assign(order, {status: canceledStage})
    },
    async openShiftModal () {
      await this.couriersRefetch()

      let currentDate = this.$moment()
      let shiftDay = this.$moment(this.shiftDay)
      if (currentDate.hour() >= 0 && currentDate.hour() <= 4 && currentDate.diff(shiftDay, 'days') < 1) {
        this.shiftDay = this.$moment(this.shiftDay).subtract(1, 'days').format('YYYY-MM-DD')
      }
      this.getDataShift()
      this.$refs.closeShift.show()
    },
    async getDataShift () {
      this.loadingShift = true
      this.loadingCouriersOrders = true
      this.loadingSpending = true
      this.showedCourierOrders = new Map()

      let couriersInfo = []
      let date = this.$moment(this.shiftDay).format('YYYY-MM-DD')
      this.getShift(date)
      this.handlePickupOrders(date)

      const res = await this.$apollo.query({
        query: COURIER_STATS,
        variables: {
          day: date
        },
        fetchPolicy: 'network-only'
      })
      const orders = res.data.couriersDeliveriedOrders.nodes
      const couriersObj = {}
      orders.forEach((order) => {
        const courierId = order.idCourier

        if (!couriersObj[courierId]) {
          couriersObj[courierId] = []
        }

        couriersObj[courierId].push(order)
      })

      this.loadingCouriersOrders = false
      let discountSum = 0

      Object.keys(couriersObj).forEach((courierId) => {
        let courierOrders = couriersObj[courierId]
        if (courierOrders.length !== 0) {
          let cash = 0
          let cardInPlace = 0
          let cardOnline = 0
          let salary = 0
          let motivation = 0
          let sberbank = 0
          let paymentLink = 0
          let courierId = null
          let orderTotalTime = 0
          let inTime = 0
          let gived = 0
          let paymentChanged = false
          let notEndedOrdersCount = 0
          let courier = null
          const ordersCount = courierOrders.length

          courierOrders.forEach(order => {
            if (courierId === null) {
              courierId = order.idCourier
            }

            if (!courier && order.workerByIdCourier) {
              courier = order.workerByIdCourier
            }

            if (order.stageKeyword === STATUS_ORDER.SENDED) {
              notEndedOrdersCount++
            } else if (order.stageKeyword === STATUS_ORDER.END) {
              let totalTime = this.getTotalTime(order)
              let courierInTime = this.courieInTime(order)
              let courierClearInTime = this.courierClearInTime(order)
              cash += parseInt(order.paymentInfo.cash)
              cardInPlace += parseInt(order.paymentInfo.cardInPlace)
              cardOnline += parseInt(order.paymentInfo.cardOnline)
              sberbank += parseInt(order.paymentInfo.sberbank)
              paymentLink += parseInt(order.paymentInfo.paymentLink)
              salary += parseInt(order.priceDelivery ? order.priceDelivery : 0) + parseInt(courierInTime ? courierInTime.sum : 0) + this.calculatateGSM(order)
              motivation += parseInt(courierClearInTime ? courierClearInTime.sum : 0)
              discountSum += parseInt(order.badDiscount)
              orderTotalTime += parseInt(totalTime || 0)
              inTime += parseInt(courierInTime ? courierInTime.sum : 0)
              if (order.paymentChanged === true && !order.paymentChangingMarked) paymentChanged = true
            }
          })
          gived = cash - motivation - salary
          if (courierId !== null) {
            this.ordersByCourier.set(courierId, courierOrders)
          }
          couriersInfo.push({
            courier: Object.assign(courier || {}, { notEndedOrdersCount }),
            notEndedOrdersCount: notEndedOrdersCount > 0 ? notEndedOrdersCount : 'Нет',
            cash: cash,
            cardInPlace: cardInPlace,
            cardOnline: cardOnline,
            sberbank: sberbank,
            paymentLink: paymentLink,
            ordersCount: ordersCount,
            total: cash + cardInPlace + cardOnline + sberbank + paymentLink,
            salary: salary,
            motivation: motivation,
            gived,
            inTime: inTime,
            orderTotalTime: orderTotalTime,
            paymentChanged: paymentChanged,
            _rowVariant: 'null'
          })
        }
      })

      if (this.pickupItems.length) {
        let cash = 0
        let cardInPlace = 0
        let cardOnline = 0
        let salary = 0
        let motivation = 0
        let sberbank = 0
        let paymentLink = 0
        let orderTotalTime = 0
        let inTime = 0
        let gived = 0
        this.pickupItems.forEach((ord) => {
          let order = ord.order
          cash += parseInt(order.paymentInfo.cash)
          cardInPlace += parseInt(order.paymentInfo.cardInPlace)
          cardOnline += parseInt(order.paymentInfo.cardOnline)
          sberbank += parseInt(order.paymentInfo.sberbank)
          paymentLink += parseInt(order.paymentInfo.paymentLink)
          discountSum += parseInt(order.badDiscount)
        })
        gived = cash

        couriersInfo.push({
          courier: 'Самовывоз',
          notEndedOrdersCount: '',
          cash: cash,
          cardInPlace: cardInPlace,
          cardOnline: cardOnline,
          sberbank: sberbank,
          paymentLink: paymentLink,
          ordersCount: this.pickupItems.length,
          total: cash + cardInPlace + cardOnline + sberbank + paymentLink,
          salary: salary,
          motivation: motivation,
          gived: gived,
          inTime: inTime,
          orderTotalTime: orderTotalTime,
          _rowVariant: 'null'
        })
      }
      this.couriersStats = couriersInfo
      this.handleSpendings(date, discountSum)
    },
    async getOrderPaymentInfo (idOrder) {
      return this.$apollo.query({
        query: ORDER_PAYMENT_BY_ID_ORDER_QUERY,
        fetchPolicy: 'network-only',
        variables: { idOrder }
      }).then((res) => res.data.orderPaymentByIdOrder)
    },
    async confirmOrder (order) {
      const currentOrder = { ...order }
      const orderPaymentInfo = await this.getOrderPaymentInfo(order.id)

      if (orderPaymentInfo) {
        currentOrder.paymentInfo = orderPaymentInfo
      }

      this.currentOrder = currentOrder
      this.$refs.modalPayment.showModal()
    },
    updatedPayment () {
      let stagePassed = this.orderStages.find(stage => stage.keyword === STATUS_ORDER.PASSED)
      this.mutateOrderToDel(this.currentOrder, null, null, stagePassed).then(() => {
        this.$apollo.queries.deliveries.refetch()
      })
    },
    copyObj (obj) {
      return JSON.parse(JSON.stringify(obj))
    },
    shortNameWorker: orderFunc.shortNameWorker,
    fullNameWorker: orderFunc.fullNameWorker,
    async openModalCloseShift (cour) {
      this.courierModal = cour
      this.$refs.courStat.show()
    },
    changeCourierStatus (cour, newStatus) {
      if (newStatus === false) {

      }
      this.$apollo.mutate({
        mutation: UPDATE_WORKER_STATUS_MUTATE,
        variables: {
          idWorker: cour.id,
          status: newStatus
        }
      }).then((data) => {
        cour.onWorkNow = newStatus
      }).catch((error) => {
        console.error(error)
      })
    },
    initHandler (val) {
      this.map = val
    },
    switchItems (items, id, scope = 'delivery') {
      if (this.IS_SUPER_LOGISTICIAN || scope === 'delivery') {
        let pos = items.indexOf(id)
        if (pos !== -1) {
          items.splice(items.indexOf(id), 1)
        } else { items.push(id) }
      } else {
        Vue.notify({
          group: 'callCenterInfo',
          type: 'error',
          title: 'Ошибка',
          text: 'Вы не можете создавать доставки, этим занимается привилегированный сотрудник.',
          duration: 1000
        })
      }
    },
    async unionOrders () {
      if (this.selectedOrders.length > 0) {
        await this.$apollo.mutate({
          mutation: graphqlLogistian.CREATE_DELIVERY_FROM_ORDERS,
          variables: {
            orderIds: this.selectedOrders
          }
        }).then(async (data) => {
          this.$apollo.queries.orders.refetch()
          this.$apollo.queries.deliveries.refetch()
          this.selectedOrders = []
        }).catch((error) => {
          console.error(error)
        })
      }
    },
    calcSumDelivery (delivery) {
      let sum = 0
      delivery.orders.forEach(order => {
        if (order.typeDelivery.keyword === TYPE_DELIVERY.DELIVERY) {
          sum += parseFloat(order.price)
        }
      })
      return sum
    },
    mutateOrderToDel (order, del, cour = null, stage = null) {
      return this.$apollo.mutate({
        mutation: UPDATE_ORDER_DELIVERY,
        variables: {
          idOrder: order.id,
          idDelivery: del ? del.id : null,
          idCourier: cour ? cour.id : null,
          idStage: stage ? stage.id : null
        }
      }).then(async (data) => {
        order.courier = cour
        if (stage !== null) {
          order.stageKeyword = stage.keyword
          order.idStage = stage.id
        }
      }).catch((error) => {
        console.error(error)
      })
    },
    appointCourier: function () {
      if (this.selectedDeliveries.length > 0) {
        this.$apollo.mutate({
          mutation: graphqlLogistian.DELIVERIES_APPOINT_COURIER,
          variables: {
            deliveriesIds: this.selectedDeliveries,
            idCourier: this.selectedCourier
          }
        }).then((data) => {
          this.$apollo.queries.deliveries.refetch()
        }).catch((error) => {
          this.selectedDeliveries = []
          console.error(error)
        })
        this.selectedDeliveries = []
        this.selectedCourier = null
      }
    },
    async getCoord (addr) {
      let pos = [null, null]
      try {
        const res = await this.$apollo.mutate({
            mutation: SH_GEOCODE_CRM,
            variables: {
              address: addr
            }
        })
        const coords = res.data.shGeocodeCrm.string.slice(1, -1).split(',')
        if ('NULL' !== coords[0] && 'NULL' !== coords[1]) {
            pos = coords.map(el => { return parseFloat(el) })
        }
      } catch (e) {
      }
      return pos
    },
    primaryAddress: function (addr) {
      let adStr = ''
      adStr += addr.street + ' ' + addr.house
      return adStr
    },
    async updatePlacemarks () {
      let marks = []
      if (this.mapShowOrders) {
        for (let i = 0; i < this.deliveryOrders.length; i++) {
          let ord = this.deliveryOrders[i]
          let coords = []
          if (ord.coords === null) {
            let address = [(ord.city || 'Тюмень') + ',', ord.street, ord.house].join(' ');
            coords = await this.getCoord(address)
          } else {
            coords = JSON.parse(ord.coords)
          }
          let forTime = ord.forTime ? this.$options.filters.timeByFullTime(ord.forTime) : this.$options.filters.time(this.$moment(ord.time).add(1, 'hours'))
          marks.push({
            markerId: ord.id,
            markerType: 'placemark',
            iconCaption: '#' + ord.idDay + ` ${forTime}`,
            coords: coords
          })
        }
      }
      if (this.mapShowDeliveries) {
        for (let i = 0; i < this.deliveries.length; i++) {
          let del = this.deliveries[i]
          for (let j = 0; j < del.orders.length; j++) {
            let ord = del.orders[j]
            let coords = []
            if (ord.coords === null) {
              let address = [(ord.city || 'Тюмень') + ',', ord.street, ord.house].join(' ');
              coords = await this.getCoord(address)
            } else {
              coords = JSON.parse(ord.coords)
            }
            let forTime = ord.forTime ? this.$options.filters.timeByFullTime(ord.forTime) : this.$options.filters.time(this.$moment(ord.time).add(1, 'hours'))
            marks.push({
              markerId: ord.id,
              markerType: 'placemark',
              iconCaption: '#' + ord.idDay + ` ${forTime}`,
              coords: coords
            })
          }
        }
      }
      this.placemarks = marks
    },
    changeIconsMarks () {
      let ordersInDel = []
      this.deliveriesWork.forEach((del) => {
        if (this.selectedDeliveries.includes(del.id)) {
          del.orders.forEach((ord) => {
            ordersInDel.push(ord.id)
          })
        }
      })
      this.placemarks.forEach((mark) => {
        if (this.selectedOrders.includes(mark.markerId) || ordersInDel.includes(mark.markerId)) {
          mark.icon = {color: 'red'}
        } else {
          mark.icon = {color: 'blue'}
        }
      })
    },
    /**
     * Disband and delete delivery by delivery object
     * @param del Object - delivery
     * */
    disbandDelivery (del) {
      this.$apollo.mutate({
        mutation: graphqlLogistian.DISBAND_DELIVERY,
        variables: {
          deliveryId: del.id
        }
      }).then((data) => {
        this.$apollo.queries.orders.refetch()
        this.$apollo.queries.deliveries.refetch()
      }).catch((error) => {
        console.error(error)
      })
    },
    /**
     * Appoint courier to delivery and it's orders
     * */
    giveToCourier (delivParam, courierParam) {
      let deliveries = []
      let courier = null
      if (!delivParam) {
        deliveries = this.deliveriesWork.filter(del => this.selectedDeliveries.includes(del.id))
      } else {
        deliveries = [delivParam]
      }
      let mutatesDeliveries = []
      this.isGivingToCourier = true
      deliveries.forEach(delivery => {
        mutatesDeliveries.push(this.$apollo.mutate({
          mutation: graphqlLogistian.GIVE_DELIVERY_TO_COURIER,
          variables: {
            idDelivery: delivery.id,
            idCourier: courier ? courier.id : null
          }
        }).then((data) => {}).catch((error) => {
          console.error(error)
        }))
      })
      Promise.all(mutatesDeliveries).then(res => {
        this.isGivingToCourier = false
        // this.$apollo.queries.couriers.refetch()
        this.couriersRefetch()
      })
      this.selectedDeliveries = []
    },
    assignToCourier (delivery, courier) {
      if (this.selectedOrdersModal.length !== 0) {
        this.$apollo.mutate({
          mutation: graphqlLogistian.ASSIGN_ORDERS_TO_COURIER,
          variables: {
            idDelivery: delivery.id,
            orderIds: this.selectedOrdersModal,
            idCourier: courier.id
          }
        }).then((res) => {
          this.selectedOrdersModal = []
          this.$apollo.queries.orders.refetch()
          this.$apollo.queries.deliveries.refetch()
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    selectOrder (order) {
      if (this.selectedDeliveryModal && order.idDelivery !== this.selectedDeliveryModal) { this.selectedOrdersModal = [] }
      this.selectedDeliveryModal = order.idDelivery

      let pos = this.selectedOrdersModal.indexOf(order.id)
      if (pos !== -1) {
        this.selectedOrdersModal.splice(pos, 1)
      } else {
        this.selectedOrdersModal.push(order.id)
      }
    },
    courierArrived (courier) {
      let statusWorker = this.courierStages.find(stage => stage.keyword === STATUS_WORKER.WAITING)
      this.$apollo.mutate({
        mutation: UPDATE_WORKER_STATUS_MUTATE,
        variables: {
          idWorker: courier.id,
          status: true,
          idStage: statusWorker.id
        }
      }).then((data) => {
        courier.onWorkNow = true
        courier.status = statusWorker
        courier.deliverySum = null
      }).catch((error) => {
        console.error(error)
      })
    },
    addOrderToDelivery (del) {
      delete del.existOrders
      this.$apollo.mutate({
        mutation: graphqlLogistian.ADD_ORDER_TO_DELIVERY,
        variables: {
          deliveryId: del.id,
          orderIds: this.selectedOrders
        }
      }).then(async (data) => {
        this.$apollo.queries.orders.refetch()
        this.$apollo.queries.deliveries.refetch()
      }).catch((error) => {
        console.error(error)
      })
      this.selectedOrders = []
    },
    deleteSpending (spending) {
      this.$apollo.mutate({
        mutation: DELETE_SPENDING,
        variables: {id: spending.id}
      }).then(() => {
        this.additionalSpending.splice(this.additionalSpending.findIndex(spend => spend.id === spending.id), 1)
      })
    },
    getTimeTitle (item) {
      let order = item.order
      if (order) {
        let timeInfoText = 'Заказ не завершен'
        let totalTime = this.getTotalTime(order)
        if (totalTime) {
          let [cookingT, collectingT, deliveryTime] = [this.getCookingTime(order), this.getCollectingTime(order), this.getDeliveryTime(order)]
          let str = [cookingT, collectingT, deliveryTime].filter(x => x !== null).join('+')
          timeInfoText = totalTime + (str !== '' && str !== '0' ? (' (' + str + ')') : '') + ' мин.'
        }
        return timeInfoText
      }
    },
    getCookingTime (order) {
      return this.getTime(order, STATUS_ORDER.COOKING, STATUS_ORDER.COOKED)
    },
    getCollectingTime (order) {
      return this.getTime(order, STATUS_ORDER.COOKED, STATUS_ORDER.SENDED)
    },
    getDeliveryTime (order) {
      return this.getTime(order, STATUS_ORDER.SENDED, STATUS_ORDER.PASSED)
    },
    getTotalTime (order) {
      return this.getTime(order, STATUS_ORDER.COOKING, STATUS_ORDER.PASSED)
    },
    getTime (order, stageFrom, stageTo) {
      let timeInMinutes = null
      let statuses = order.statuses.nodes
      if (statuses.length !== 0) {
        let cookingStage = statuses.find(status => status.stage.keyword === stageFrom)
        let passedStage = statuses.find(status => status.stage.keyword === stageTo)

        if (cookingStage && passedStage) {
          let timeDiff = this.$moment(cookingStage.time)
          let passedTime = this.$moment(passedStage.time)
          timeInMinutes = passedTime.diff(timeDiff, 'minutes')
        }
      }
      return timeInMinutes
    },
    courieInTime (order) {
      if (!order || !order.delivery) {
        return null
      }

      let timeInMinutes = this.getTotalTime(order)
      if (order.delivery.restpoint && order.delivery.restpoint.targetTimeDeliveryIn && order.delivery.restpoint.targetSumDeliveryIn && timeInMinutes <= order.delivery.restpoint.targetTimeDeliveryIn) {
        return {
          in_time: true,
          sum: order.delivery.restpoint.targetSumDeliveryIn
        }
      } else if (order.delivery.restpoint && order.delivery.restpoint.targetSumDeliveryOut) {
        return {
          in_time: false,
          sum: order.delivery.restpoint.targetSumDeliveryOut
        }
      }
      return null
    },
    courierClearInTime (order) {
      let timeInMinutes = this.getDeliveryTime(order)
      if (order.delivery.restpoint && order.delivery.restpoint.clearTargetTimeDeliveryIn && order.delivery.restpoint.clearTargetSumDeliveryIn && timeInMinutes <= order.delivery.restpoint.clearTargetTimeDeliveryIn) {
        return {
          in_time: true,
          sum: order.delivery.restpoint.clearTargetSumDeliveryIn
        }
      }
      return null
    },
    toggleCourierOrders (item) {
      if (item.courier !== null) {
        let index = item.courier === 'Самовывоз' ? 'Самовывоз' : item.courier.id
        let indexRow = item.courier === 'Самовывоз' ? this.couriersStats.findIndex(cour => cour.courier && cour.courier === index) : this.couriersStats.findIndex(cour => cour.courier && cour.courier.id === index)
        if (!this.showedCourierOrders.get(index)) {
          let orders
          if (item.courier === 'Самовывоз') {
            this.showedCourierOrders.set('Самовывоз', true)
            orders = this.pickupItems
          } else {
            this.showedCourierOrders.set(index, true)
            orders = this.ordersByCourier.get(index)
          }
          this.couriersStats[indexRow]._rowVariant = 'primary'
          let indexToInsert = indexRow + 1
          orders.forEach(ord => {
            let gived
            if (item.courier === 'Самовывоз') {
              ord = ord.order
            } else {
              Object.assign(ord, {
                motivation: this.courierClearInTime(ord)
              })
            }
            let courierInTime = this.courieInTime(ord)
            gived = parseInt(ord.paymentInfo.cash) - parseInt(ord.priceDelivery ? ord.priceDelivery : 0) - parseInt(courierInTime ? courierInTime.sum : 0) - this.calculatateGSM(ord)
            let totalTime = item.courier === 'Самовывоз' ? 0 : this.getTotalTime(ord)
            this.couriersStats.splice(indexToInsert, 0, {
              order: ord,
              courier: null,
              orderTotalTime: parseInt(totalTime || 0),
              cash: parseInt(ord.paymentInfo.cash),
              cardInPlace: parseInt(ord.paymentInfo.cardInPlace),
              cardOnline: parseInt(ord.paymentInfo.cardOnline),
              ordersCount: 1,
              sberbank: parseInt(ord.paymentInfo.sberbank),
              paymentLink: parseInt(ord.paymentInfo.paymentLink),
              total: parseInt(ord.paymentInfo.cash) + parseInt(ord.paymentInfo.cardInPlace) + parseInt(ord.paymentInfo.cardOnline) + parseInt(ord.paymentInfo.sberbank) + parseInt(ord.paymentInfo.paymentLink),
              gived: gived,
              salary: parseInt(ord.priceDelivery ? ord.priceDelivery : 0),
              motivation: ord.motivation ? ord.motivation.sum : 0,
              inTime: item.courier === 'Самовывоз' ? null : this.courieInTime(ord),
              inTimeClear: item.courier === 'Самовывоз' ? null : this.courierClearInTime(ord),
              paymentChanged: ord.paymentChanged && !ord.paymentChangingMarked
            })
          })
        } else {
          if (item.courier === 'Самовывоз') {
            this.showedCourierOrders.set('Самовывоз', false)
          } else {
            this.showedCourierOrders.set(index, false)
          }
          let indexToDelete = indexRow + 1
          this.couriersStats[indexRow]._rowVariant = null
          while (this.couriersStats[indexToDelete] && this.couriersStats[indexToDelete].courier === null) {
            this.couriersStats.splice(indexToDelete, 1)
          }
        }
      }
    },
    async closeShift (e) {
      const closeAvailability = await this.closeAvailabilityCheck()

      if (closeAvailability === false) {
        e.preventDefault()
        this.showConfirmationMessageBox('Для закрытия смены, нужно чтобы все курьеры были на месте')
      } else {
        this.$apollo.mutate({
          mutation: SHIFT_CLOSE
        }).then(data => {
          if (data) {
            this.$userControl.logout()
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  },
  created () {
    this.updatePlacemarks()
  },
  beforeDestroy () {
  },
  watch: {
    showAllShifts (val) {
      this.getDataShift()
    },
    shiftDay (val) {
      if (val) {
        this.getDataShift()
      }
    },
    'deliveryForDelete.orders' (val) {
      if (this.deliveryForDelete.id !== null && val.length === 0) {
        this.$apollo.mutate({
          mutation: DELETE_DELIVERY,
          variables: {
            id: this.deliveryForDelete.id
          }
        }).then((data) => {
          this.deliveries.splice(this.deliveries.findIndex(el => el.id === this.deliveryForDelete.id), 1)
        }).catch((error) => {
          console.error(error)
        })
      }
    },
    mapShowOrders () {
      this.updatePlacemarks()
    },
    mapShowDeliveries () {
      this.updatePlacemarks()
    },
    orders () {
      this.updatePlacemarks()
    },
    selectedOrders () {
      this.changeIconsMarks()
    },
    selectedDeliveries () {
      this.changeIconsMarks()
    }
  },
  computed: {
    yandexSearchProvider () {
      // Не кладём в data() - иначе Vue сделает провайдер реактивным, а SearchControl
      // передаёт его же обратно в options при каждом вызове suggest/geocode, что приводит
      // к переполнению стека при попытке сериализовать options для ключа кэша.
      return yandexSearchProviderModule
    },
    IS_SUPER_LOGISTICIAN () {
      return this.$user.get().role === USER_ROLE_SUPER_LOGISTICIAN
    },
    CAA_IS_ON () {
      return this.accountRestPoint ? this.accountRestPoint.CAA : false
    },
    isShiftClosed () {
      return this.currentShift && this.currentShift.dateClosed !== null
    },
    shiftOpened () {
      if (this.currentShift) {
        return this.$moment(this.currentShift.dateOpened).format('YYYY-MM-DD H:mm:ss')
      } return false
    },
    shiftClosed () {
      if (this.currentShift) {
        return this.$moment(this.currentShift.dateClosed).format('YYYY-MM-DD H:mm:ss')
      }
    },
    courierStageWaiting () {
      return this.courierStages.find(el => el.keyword === STATUS_WORKER.WAITING)
    },
    sumCash () {
      return this.couriersStats.reduce((val, el) => { return val + (el.courier || el.pickup ? parseInt(el.cash) : 0) }, 0)
    },
    sumSalary () {
      return this.couriersStats.reduce((val, el) => { return val + (el.courier ? parseInt(el.salary) : 0) }, 0)
    },
    sumMotivation () {
      return this.couriersStats.reduce((val, el) => { return val + (el.courier ? parseInt(el.motivation) : 0) }, 0)
    },
    sumInTime () {
      return this.couriersStats.reduce((val, el) => { return val + (el.courier ? parseInt(el.inTime) : 0) }, 0)
    },
    sumCardOnline () {
      return this.couriersStats.reduce((val, el) => { return val + (el.courier ? parseInt(el.cardOnline) : 0) }, 0)
    },
    sumCardInPlace () {
      return this.couriersStats.reduce((val, el) => { return val + (el.courier ? parseInt(el.cardInPlace) : 0) }, 0)
    },
    sumSberbank () {
      return this.couriersStats.reduce((val, el) => { return val + (el.courier ? parseInt(el.sberbank) : 0) }, 0)
    },
    sumPaymentLink () {
      return this.couriersStats.reduce((val, el) => { return val + (el.courier ? parseInt(el.paymentLink) : 0) }, 0)
    },
    sumCosts () {
      return this.additionalSpending.reduce((val, el) => { return val + (parseInt(el.sum)) }, 0)
    },
    numberSelectedOrders () {
      return this.selectedOrders.length
    },
    permitGiveCourier () {
      let permit = !this.isGivingToCourier && this.selectedDeliveries.length > 0
      if (!permit) {
        return false
      }
      this.selectedDeliveries.forEach(selectedDeliv => {
        let selectedDelivery = this.deliveries.find(el => el.id === selectedDeliv)
        if (selectedDelivery) {
          if (selectedDelivery.courier) {
            let courier = this.couriersOnWork.find((el) => el.id === selectedDelivery.courier.id)
            permit &= courier.onWorkNow === true
          } else permit &= false

          permit &= selectedDelivery.status.keyword === STATUS_DELIVERY.CHOSEN_COURIER
          selectedDelivery.orders.forEach(order => {
            permit &= order.stageKeyword === STATUS_ORDER.COLLECTED
          })
        } else permit &= false
      })
      return permit
    },
    deliveriesWork () {
      return this.deliveries.filter(el => el.status.keyword === STATUS_DELIVERY.NEW || el.status.keyword === STATUS_DELIVERY.CHOSEN_COURIER)
    },
    deliveryOrders () {
      return this.orders.filter((ord) => ord.typeDelivery.keyword === TYPE_DELIVERY.DELIVERY)
    },
    pickupOrders () {
      return this.orders.filter((ord) => ord.typeDelivery.keyword === TYPE_DELIVERY.PICKUP)
    },
    couriers () {
      return [...this.couriersOnWork, ...this.couriersFree]
    },
    orderStagesObj () {
      return this.orderStages.reduce((acc, item) => ({...acc, [item.id]: item}), {})
    }
  },
  components: {
    ModalPaymentInfo,
    CourierStatDisplay,
    CancelOrderModal,
    DeliveryItem,
    TimeCounter,
    OrderRow
  }
}
</script>

<style lang="scss">
    .rectangle {
      display: inline-flex;
      width: 25px;
      height: 25px;
    }
    tr.order-prods.in-time td {
      background-color: rgb(226, 255, 230);
    }
    tr.order-prods.in-clear-time td {
      background-color: rgb(118, 234, 134);
    }
    tr.order-prods.not-in-time td {
      background-color: rgb(255, 204, 204);
    }
    .tabs-delivery {
        height: calc(100% - 46px);
    }
    .two-digit-inp {
        width: 65px;
        text-align: center;
        display:inline-block;
    }
    .orders, .deliveries {
        > * {
            cursor:pointer;
            &:hover:not(.nohover) {
                background: #dbeab42;
            }
            &.activeIt {
                background: #eeffc4;
            }
        }
    }
    .couriers.card-group {
      flex-flow: row;
    }
    .couriers .card:not(.controlCouriers) {
      width: 100%;
      max-width: none;
      min-width: 160px;
      display: flex;
      & * {
        font-size: 0.85rem;
      }
      .card-header {
          height: 60px;
          padding: 0.4rem;
        h6 {
          button {
            margin-left: 0.5em;
            align-self: baseline;
          }
        }
      }
      .courier-statuses.list-group {
        min-height: 50px;
      }
      &.activeIt {
          background: #eeffc4;
          .list-group-item {
              background: #eeffc4;
          }
      }
      &:hover:not(.nohover) {
          background: #DBEAB4;
          .list-group-item {
              background: #dbeab42;
          }
      }
    }
    .couriers {
      .couriers-ps {
        width: 100%;
      }
    }
    tr.order-prods td {
      &.courier-payment-changed {
        background-color: rgb(255, 60, 60);
      }
      &.payment-changed {
        background-color: rgb(255, 130, 130);
      }
      vertical-align: middle;
    }
    .orderInDelivery {
        border-left:1px solid #DFDFDF;
        border-right:1px solid #DFDFDF;

    }
    .controlCouriers {
        flex:0 0 50px!important;
    }
    .tab-orders {
        display: flex;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .deliveries-orders {
        height: calc(100vh - 53px - 106px - 10px - 10px - 50px - 30px - 75px);
    }
    .pickup-orders {
        height: calc(100vh - 53px - 106px - 10px - 10px - 50px - 75px);
    }
    .pointer {
        cursor:pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/OrdersDelivery.vue